import { useEffect } from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DataGridProvider } from '@issuemanager/apps/client/components';
import { useSetHeaderProps } from '@issuemanager/apps/client/contexts';
import { SLAS_GRID_KEY } from './constants';
import { SLAsGrid } from './components/slas-grid/slas-grid';

export default function () {
  const { t } = useTranslation(['common', 'settings']);
  const setHeaderProps = useSetHeaderProps();

  useEffect(() => {
    setHeaderProps({
      viewTitle: {
        breadcrumbSections: [{ url: '/', title: t('common:appName') }],
        title: t('settings:routeName'),
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box px={4} py={4}>
      <DataGridProvider storageKey={SLAS_GRID_KEY}>
        <SLAsGrid />
      </DataGridProvider>
    </Box>
  );
}
